import { render } from "./RemoveSpeakerModal.vue?vue&type=template&id=968354ee"
import script from "./RemoveSpeakerModal.vue?vue&type=script&lang=js"
export * from "./RemoveSpeakerModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__